import { All, KeyValue, Query } from "../interfaces";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import { Dispatch } from "react";
import SummaryTables from "../components/SOD/SummaryTables/SummaryTables";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    resetState: (state: Query) => {
      dispatch(actions.resetState(state));
      dispatch(actions.searchPush());
    },
    updateSort: (sortField: string, sortDirection: string) => {
      dispatch(actions.updateSortOrder(sortField, sortDirection));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SummaryTables);
